
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AlertScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  timeUnit: 'timeUnit',
  timeValue: 'timeValue',
  type: 'type',
  enabled: 'enabled',
  notificationBefore: 'notificationBefore'
};

exports.Prisma.ConsumptionAnalyzerTrainingDataScalarFieldEnum = {
  id: 'id',
  duration: 'duration',
  startHour: 'startHour',
  fullHourConsumption: 'fullHourConsumption',
  elementId: 'elementId',
  timeRecorded: 'timeRecorded'
};

exports.Prisma.ConsumptionReportElementScalarFieldEnum = {
  id: 'id',
  name: 'name',
  reportId: 'reportId',
  totalConsumption: 'totalConsumption',
  timesUsed: 'timesUsed',
  averageOnTime: 'averageOnTime',
  points: 'points'
};

exports.Prisma.ConsumptionReportScalarFieldEnum = {
  id: 'id',
  from: 'from',
  to: 'to',
  objectId: 'objectId',
  totalConsumption: 'totalConsumption',
  type: 'type',
  totalPoints: 'totalPoints',
  temperature: 'temperature',
  expensiveHoursAmount: 'expensiveHoursAmount',
  usageInExpensiveHourAmount: 'usageInExpensiveHourAmount',
  baselineExchangeCost: 'baselineExchangeCost',
  nonBaselineExchangeCost: 'nonBaselineExchangeCost',
  baselineCost: 'baselineCost',
  nonBaselineCost: 'nonBaselineCost'
};

exports.Prisma.PriceTrackersScalarFieldEnum = {
  id: 'id',
  limitType: 'limitType',
  enabled: 'enabled',
  value: 'value',
  lastTriggered: 'lastTriggered',
  userId: 'userId'
};

exports.Prisma.NotificationSubscriptionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  consumptionElementId: 'consumptionElementId'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  headerFi: 'headerFi',
  headerEn: 'headerEn',
  contentFi: 'contentFi',
  contentEn: 'contentEn',
  type: 'type',
  linkTarget: 'linkTarget',
  modalLinkTarget: 'modalLinkTarget',
  modalVariable: 'modalVariable',
  time: 'time',
  isDeletedOn: 'isDeletedOn',
  isRead: 'isRead',
  isReadOn: 'isReadOn'
};

exports.Prisma.ConsumptionElementScalarFieldEnum = {
  id: 'id',
  name: 'name',
  minConsumption: 'minConsumption',
  maxConsumption: 'maxConsumption',
  objectId: 'objectId',
  secondBaseline: 'secondBaseline',
  timeRestriction: 'timeRestriction',
  disabled: 'disabled',
  durationTypical: 'durationTypical',
  durationLowLimit: 'durationLowLimit',
  durationHighLimit: 'durationHighLimit',
  consumptionTypical: 'consumptionTypical',
  consumptionLowLimit: 'consumptionLowLimit',
  consumptionHighLimit: 'consumptionHighLimit',
  timeStartStrict: 'timeStartStrict',
  timeEndStrict: 'timeEndStrict',
  timeStartTypical: 'timeStartTypical',
  type: 'type',
  timingNotificationThreshold: 'timingNotificationThreshold',
  custom: 'custom'
};

exports.Prisma.ObjectRoomScalarFieldEnum = {
  id: 'id',
  squares: 'squares',
  temperature: 'temperature',
  objectId: 'objectId',
  name: 'name'
};

exports.Prisma.ObjectScalarFieldEnum = {
  id: 'id',
  heatingType: 'heatingType',
  userId: 'userId',
  type: 'type',
  squares: 'squares',
  heatPump: 'heatPump',
  underfloorHeating: 'underfloorHeating',
  fireplace: 'fireplace',
  temperature: 'temperature',
  moneySaved: 'moneySaved',
  brainNet: 'brainNet',
  personCount: 'personCount',
  contractType: 'contractType',
  spotMarginal: 'spotMarginal',
  monthlyPrice: 'monthlyPrice',
  contractEndDate: 'contractEndDate',
  contractEndDateType: 'contractEndDateType',
  gsrn: 'gsrn',
  productionGsrn: 'productionGsrn',
  dhAuthEndDate: 'dhAuthEndDate',
  useDatahub: 'useDatahub',
  synerallId: 'synerallId',
  streetAddress: 'streetAddress',
  zipCode: 'zipCode',
  city: 'city',
  synerallContractId: 'synerallContractId',
  synerallProductionId: 'synerallProductionId',
  showMonthlyPrice: 'showMonthlyPrice',
  disabledOn: 'disabledOn',
  fixedPrice: 'fixedPrice',
  houseNumber: 'houseNumber',
  productionMargin: 'productionMargin',
  chargingLocationId: 'chargingLocationId',
  panelMaxPower: 'panelMaxPower',
  hvacAwayMode: 'hvacAwayMode',
  savedTemperature: 'savedTemperature',
  electricityTransferPriceId: 'electricityTransferPriceId',
  electricityTransferMonthlyPrice: 'electricityTransferMonthlyPrice',
  electricityTransferPricePerKwh: 'electricityTransferPricePerKwh',
  electricityTransferPriceContractType: 'electricityTransferPriceContractType',
  electricityTransferPriceContractDayPrice: 'electricityTransferPriceContractDayPrice',
  electricityTransferPriceContractNightPrice: 'electricityTransferPriceContractNightPrice',
  manualSetConsumptionProvider: 'manualSetConsumptionProvider',
  electricityTaxIncluded: 'electricityTaxIncluded'
};

exports.Prisma.ReportScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  from: 'from',
  to: 'to',
  type: 'type',
  totalConsumption: 'totalConsumption',
  totalCO2: 'totalCO2',
  totalBill: 'totalBill',
  personCount: 'personCount',
  temperature: 'temperature',
  heatingConsumption: 'heatingConsumption',
  heatingCO2: 'heatingCO2',
  applianceConsumption: 'applianceConsumption',
  applianceCO2: 'applianceCO2',
  heatingType: 'heatingType',
  lastUpdated: 'lastUpdated'
};

exports.Prisma.SavingEventScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  date: 'date',
  appliance: 'appliance',
  saving: 'saving',
  confidence: 'confidence',
  consumption: 'consumption',
  periodType: 'periodType',
  weekStart: 'weekStart',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SavingEventCalcScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  date: 'date',
  status: 'status',
  eventCount: 'eventCount',
  periodType: 'periodType',
  weekStart: 'weekStart',
  processedAt: 'processedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SavingProgramCaseScalarFieldEnum = {
  id: 'id',
  type: 'type',
  reductionGoal: 'reductionGoal',
  consumptionElementId: 'consumptionElementId',
  startValue: 'startValue',
  objectId: 'objectId',
  savingOnSuccess: 'savingOnSuccess',
  createdOn: 'createdOn',
  goalDate: 'goalDate',
  firstSuccessful: 'firstSuccessful'
};

exports.Prisma.HeatingCaseScalarFieldEnum = {
  id: 'id',
  objectId: 'objectId',
  enabled: 'enabled',
  goalTemperature: 'goalTemperature',
  initialTemperature: 'initialTemperature',
  currentEstimatedTemperature: 'currentEstimatedTemperature',
  estimatedSavings: 'estimatedSavings',
  savingsRightNow: 'savingsRightNow'
};

exports.Prisma.UsageDayScalarFieldEnum = {
  id: 'id',
  elementId: 'elementId',
  day: 'day'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  encryptedSsn: 'encryptedSsn',
  email: 'email',
  password: 'password',
  personalId: 'personalId',
  appId: 'appId',
  selectedContract: 'selectedContract',
  preference: 'preference',
  interestedInTech: 'interestedInTech',
  level: 'level',
  tempPassword: 'tempPassword',
  registeredDate: 'registeredDate',
  lastLogin: 'lastLogin',
  selectedObject: 'selectedObject',
  hashedPid: 'hashedPid',
  landingPage: 'landingPage',
  versionNumber: 'versionNumber',
  showMonthlyPrice: 'showMonthlyPrice',
  fcmRegToken: 'fcmRegToken',
  fireplaceNotificationEnabled: 'fireplaceNotificationEnabled',
  alertEnabled: 'alertEnabled',
  alertTimeValue: 'alertTimeValue',
  alertTimeUnit: 'alertTimeUnit',
  autoliittoMembershipNumber: 'autoliittoMembershipNumber',
  provider: 'provider',
  platform: 'platform',
  vehicleLinked: 'vehicleLinked',
  panelLinked: 'panelLinked',
  hvacLinked: 'hvacLinked',
  requestedReviewOn: 'requestedReviewOn',
  language: 'language',
  termsAccepted: 'termsAccepted',
  isMigrated: 'isMigrated',
  firebaseId: 'firebaseId',
  roleNames: 'roleNames'
};

exports.Prisma.UserSettingsScalarFieldEnum = {
  id: 'id',
  weeklyNewsNotisEnabled: 'weeklyNewsNotisEnabled',
  lateExchangePriceNotisEnabled: 'lateExchangePriceNotisEnabled',
  trackerNotisEnabled: 'trackerNotisEnabled',
  hourlyTrackerNotisEnabled: 'hourlyTrackerNotisEnabled',
  tomorrowPricesNotisEnabled: 'tomorrowPricesNotisEnabled',
  monthlyReportNotisEnabled: 'monthlyReportNotisEnabled',
  newInvoiceAvailableNotisEnabled: 'newInvoiceAvailableNotisEnabled',
  smartChargingInfoNotisEnabled: 'smartChargingInfoNotisEnabled',
  weeklyNewsEmailEnabled: 'weeklyNewsEmailEnabled',
  lateExchangePriceEmailEnabled: 'lateExchangePriceEmailEnabled',
  trackerEmailEnabled: 'trackerEmailEnabled',
  hourlyTrackerEmailEnabled: 'hourlyTrackerEmailEnabled',
  tomorrowPricesEmailEnabled: 'tomorrowPricesEmailEnabled',
  monthlyReportEmailEnabled: 'monthlyReportEmailEnabled',
  newInvoiceAvailableEmailEnabled: 'newInvoiceAvailableEmailEnabled',
  smartChargingInfoEmailEnabled: 'smartChargingInfoEmailEnabled',
  tomorrowPricesInfoEmailEnabled: 'tomorrowPricesInfoEmailEnabled',
  themeMode: 'themeMode',
  solarChargingEnabled: 'solarChargingEnabled',
  solarChargingActive: 'solarChargingActive',
  solarChargingTurnoffThreshold: 'solarChargingTurnoffThreshold',
  solarChargingTurnonThreshold: 'solarChargingTurnonThreshold',
  smartHeatingEnabled: 'smartHeatingEnabled',
  smartHeatingActive: 'smartHeatingActive',
  smartHeatingNormalTemperature: 'smartHeatingNormalTemperature',
  smartHeatingSavingTemperature: 'smartHeatingSavingTemperature',
  userId: 'userId',
  bankAccountNumber: 'bankAccountNumber'
};

exports.Prisma.ConsumptionStatisticsScalarFieldEnum = {
  id: 'id',
  personCount: 'personCount',
  from: 'from',
  to: 'to',
  timeframe: 'timeframe',
  totalConsumption: 'totalConsumption',
  totalCO2: 'totalCO2',
  totalHeatingConsumption: 'totalHeatingConsumption',
  heatingCO2: 'heatingCO2'
};

exports.Prisma.NotificationStatisticsScalarFieldEnum = {
  id: 'id',
  sentDate: 'sentDate',
  notificationType: 'notificationType',
  totalSent: 'totalSent',
  successfulSent: 'successfulSent',
  failedSent: 'failedSent'
};

exports.Prisma.OfferedContractsScalarFieldEnum = {
  id: 'id',
  marginalPrice: 'marginalPrice'
};

exports.Prisma.NewContractScalarFieldEnum = {
  id: 'id',
  contractStartDate: 'contractStartDate',
  firstName: 'firstName',
  lastName: 'lastName',
  ssn: 'ssn',
  email: 'email',
  phone: 'phone',
  invoiceType: 'invoiceType',
  newContractType: 'newContractType',
  noAds: 'noAds',
  streetAddress: 'streetAddress',
  houseNumber: 'houseNumber',
  stairwellIdentification: 'stairwellIdentification',
  apartment: 'apartment',
  zipCode: 'zipCode',
  gsrn: 'gsrn',
  city: 'city',
  invoicestreetAddress: 'invoicestreetAddress',
  invoicehouseNumber: 'invoicehouseNumber',
  invoicestairwellIdentification: 'invoicestairwellIdentification',
  invoiceapartment: 'invoiceapartment',
  invoicezipCode: 'invoicezipCode',
  invoicecity: 'invoicecity',
  recommenderEmail: 'recommenderEmail',
  productId: 'productId',
  productName: 'productName',
  creationDate: 'creationDate',
  processedDate: 'processedDate',
  language: 'language',
  provider: 'provider',
  cancellationRequestedDate: 'cancellationRequestedDate',
  cancellationReason: 'cancellationReason',
  isLockIn: 'isLockIn',
  lockInName: 'lockInName',
  lockInPeriod: 'lockInPeriod',
  lockInProductId: 'lockInProductId',
  lockInHourlyPrice: 'lockInHourlyPrice',
  lockInMonthlyPrice: 'lockInMonthlyPrice',
  lockInValidFrom: 'lockInValidFrom',
  lockInValidTo: 'lockInValidTo',
  lockInRatio: 'lockInRatio',
  isContractUpdate: 'isContractUpdate',
  isMobile: 'isMobile',
  adtractionId: 'adtractionId',
  ltv: 'ltv'
};

exports.Prisma.ElectricityTransferPricesScalarFieldEnum = {
  id: 'id',
  companyName: 'companyName',
  monthlyPrice: 'monthlyPrice',
  pricePerKwh: 'pricePerKwh',
  isLatest: 'isLatest',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  versionNumber: 'versionNumber'
};

exports.Prisma.ConfigurationScalarFieldEnum = {
  key: 'key',
  value: 'value',
  updatedAt: 'updatedAt'
};

exports.Prisma.AppInsightsScalarFieldEnum = {
  id: 'id',
  timestamp: 'timestamp',
  date: 'date',
  androidUsers: 'androidUsers',
  iosUsers: 'iosUsers',
  synerallObjects: 'synerallObjects',
  datahubObjects: 'datahubObjects',
  connectedHvacs: 'connectedHvacs',
  connectedInverters: 'connectedInverters',
  connectedVehicles: 'connectedVehicles',
  userCount: 'userCount',
  usersActive1Day: 'usersActive1Day',
  usersActive7Days: 'usersActive7Days',
  usersActive30Days: 'usersActive30Days',
  usersActive60Days: 'usersActive60Days',
  usersActive90Days: 'usersActive90Days'
};

exports.Prisma.ChangelogScalarFieldEnum = {
  id: 'id',
  version: 'version',
  textEn: 'textEn',
  textFi: 'textFi',
  addedOn: 'addedOn',
  updatedOn: 'updatedOn'
};

exports.Prisma.AchievementScalarFieldEnum = {
  id: 'id',
  nameFi: 'nameFi',
  nameEn: 'nameEn',
  descFi: 'descFi',
  descEn: 'descEn',
  points: 'points',
  steps: 'steps',
  type: 'type',
  isActive: 'isActive',
  threshold: 'threshold',
  timeFrame: 'timeFrame',
  targetValue: 'targetValue',
  minValue: 'minValue',
  maxValue: 'maxValue',
  meta: 'meta'
};

exports.Prisma.UserAchievementScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  achievementId: 'achievementId',
  completedAt: 'completedAt',
  isCompleted: 'isCompleted',
  step: 'step',
  lastObservedStep: 'lastObservedStep',
  createdAt: 'createdAt',
  pointsAwarded: 'pointsAwarded'
};

exports.Prisma.BadgeScalarFieldEnum = {
  id: 'id',
  nameFi: 'nameFi',
  nameEn: 'nameEn',
  category: 'category',
  createdAt: 'createdAt'
};

exports.Prisma.BadgeTierScalarFieldEnum = {
  id: 'id',
  badgeId: 'badgeId',
  tierLevel: 'tierLevel',
  tierNameFi: 'tierNameFi',
  tierNameEn: 'tierNameEn',
  tierDescriptionFi: 'tierDescriptionFi',
  tierDescriptionEn: 'tierDescriptionEn',
  thresholdValue: 'thresholdValue',
  createdAt: 'createdAt'
};

exports.Prisma.UserBadgeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  badgeId: 'badgeId',
  tierId: 'tierId',
  earnedCount: 'earnedCount',
  lastEarnedAt: 'lastEarnedAt'
};

exports.Prisma.SeasonResultsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  season: 'season',
  points: 'points',
  savings: 'savings',
  level: 'level',
  percentage: 'percentage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SpotPricesScalarFieldEnum = {
  id: 'id',
  date: 'date',
  deliveryStart: 'deliveryStart',
  deliveryEnd: 'deliveryEnd',
  priceEurPerMwhNoVat: 'priceEurPerMwhNoVat',
  priceEurPerMwhVat: 'priceEurPerMwhVat',
  priceSntPerKwhNoVat: 'priceSntPerKwhNoVat',
  priceSntPerKwhVat: 'priceSntPerKwhVat'
};

exports.Prisma.RefreshTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  revokedAt: 'revokedAt'
};

exports.Prisma.RegularScheduleScalarFieldEnum = {
  id: 'id',
  dayOfWeek: 'dayOfWeek',
  openTime: 'openTime',
  closeTime: 'closeTime'
};

exports.Prisma.ScheduleExceptionScalarFieldEnum = {
  id: 'id',
  date: 'date',
  isClosed: 'isClosed',
  openTime: 'openTime',
  closeTime: 'closeTime',
  description: 'description'
};

exports.Prisma.DayAheadPriceScalarFieldEnum = {
  biddingZone: 'biddingZone',
  deliveryStart: 'deliveryStart',
  deliveryEnd: 'deliveryEnd',
  eurosPerMwh: 'eurosPerMwh'
};

exports.Prisma.ContactRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  objectId: 'objectId',
  data: 'data'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.TrackerType = exports.$Enums.TrackerType = {
  veryHigh: 'veryHigh',
  high: 'high',
  low: 'low',
  veryLow: 'veryLow'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  tracker: 'tracker',
  noExchangePrices: 'noExchangePrices',
  smartChargingInfo: 'smartChargingInfo',
  weeklyNews: 'weeklyNews',
  highPrices: 'highPrices',
  newInvoiceAvailable: 'newInvoiceAvailable',
  monthlyReport: 'monthlyReport',
  oldType: 'oldType',
  contractEnding: 'contractEnding',
  charging: 'charging',
  mailPrices: 'mailPrices'
};

exports.HeatingType = exports.$Enums.HeatingType = {
  district: 'district',
  geothermal: 'geothermal',
  electric: 'electric',
  timedElectric: 'timedElectric',
  oil: 'oil',
  wood: 'wood',
  airWaterHeatPump: 'airWaterHeatPump'
};

exports.ObjectType = exports.$Enums.ObjectType = {
  house: 'house',
  apartment: 'apartment',
  rowhouse: 'rowhouse',
  cottage: 'cottage',
  other: 'other'
};

exports.ContractType = exports.$Enums.ContractType = {
  spot: 'spot',
  fixed: 'fixed'
};

exports.ContractEndDateType = exports.$Enums.ContractEndDateType = {
  indefinite: 'indefinite',
  fixedTerm: 'fixedTerm'
};

exports.ApplianceType = exports.$Enums.ApplianceType = {
  fridge_freezer: 'fridge_freezer',
  small_kitchen_appliance: 'small_kitchen_appliance',
  dishwasher: 'dishwasher',
  washing_machine: 'washing_machine',
  cooking: 'cooking',
  sauna: 'sauna',
  cooling: 'cooling',
  heating: 'heating',
  consumption_effect: 'consumption_effect',
  ev: 'ev'
};

exports.SavingPeriodType = exports.$Enums.SavingPeriodType = {
  day: 'day',
  week: 'week'
};

exports.CalculationStatus = exports.$Enums.CalculationStatus = {
  pending: 'pending',
  completed: 'completed',
  failed: 'failed'
};

exports.FeedbackPreference = exports.$Enums.FeedbackPreference = {
  money: 'money',
  nature: 'nature'
};

exports.LandingPageOption = exports.$Enums.LandingPageOption = {
  overview: 'overview',
  consumption: 'consumption',
  spotMargin: 'spotMargin',
  devices: 'devices',
  saving: 'saving'
};

exports.AppServiceProvider = exports.$Enums.AppServiceProvider = {
  Alyenergia: 'Alyenergia',
  Autoliitto: 'Autoliitto'
};

exports.Language = exports.$Enums.Language = {
  fi: 'fi',
  en: 'en'
};

exports.ThemeMode = exports.$Enums.ThemeMode = {
  dark: 'dark',
  light: 'light',
  system: 'system'
};

exports.ConsumptionTimeFrame = exports.$Enums.ConsumptionTimeFrame = {
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly'
};

exports.NewContractType = exports.$Enums.NewContractType = {
  changeCompany: 'changeCompany',
  moveIn: 'moveIn',
  newContract: 'newContract',
  swapContract: 'swapContract',
  lockIn: 'lockIn'
};

exports.AchievementType = exports.$Enums.AchievementType = {
  unknown: 'unknown',
  connectDevice: 'connectDevice',
  priceTrackers: 'priceTrackers',
  consumptionEffect: 'consumptionEffect',
  becomeOurCustomer: 'becomeOurCustomer',
  smartCharging: 'smartCharging'
};

exports.DayOfWeek = exports.$Enums.DayOfWeek = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
};

exports.Prisma.ModelName = {
  Alert: 'Alert',
  ConsumptionAnalyzerTrainingData: 'ConsumptionAnalyzerTrainingData',
  ConsumptionReportElement: 'ConsumptionReportElement',
  ConsumptionReport: 'ConsumptionReport',
  PriceTrackers: 'PriceTrackers',
  NotificationSubscription: 'NotificationSubscription',
  Notification: 'Notification',
  ConsumptionElement: 'ConsumptionElement',
  ObjectRoom: 'ObjectRoom',
  Object: 'Object',
  Report: 'Report',
  SavingEvent: 'SavingEvent',
  SavingEventCalc: 'SavingEventCalc',
  SavingProgramCase: 'SavingProgramCase',
  HeatingCase: 'HeatingCase',
  UsageDay: 'UsageDay',
  User: 'User',
  UserSettings: 'UserSettings',
  ConsumptionStatistics: 'ConsumptionStatistics',
  NotificationStatistics: 'NotificationStatistics',
  OfferedContracts: 'OfferedContracts',
  NewContract: 'NewContract',
  ElectricityTransferPrices: 'ElectricityTransferPrices',
  Configuration: 'Configuration',
  AppInsights: 'AppInsights',
  Changelog: 'Changelog',
  Achievement: 'Achievement',
  UserAchievement: 'UserAchievement',
  Badge: 'Badge',
  BadgeTier: 'BadgeTier',
  UserBadge: 'UserBadge',
  SeasonResults: 'SeasonResults',
  SpotPrices: 'SpotPrices',
  RefreshToken: 'RefreshToken',
  RegularSchedule: 'RegularSchedule',
  ScheduleException: 'ScheduleException',
  DayAheadPrice: 'DayAheadPrice',
  ContactRequest: 'ContactRequest'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
